export default __webpack_public_path__ + "static/media/ResetPassword.7ef6981f.png";